export default "__VITE_ASSET__CyT0DhD1__"